import React from 'react';
import cx from 'classnames';
import Icon from '../../../../components/Icon';
import styles from './Item.m.sass';
export var Item = function Item(_ref) {
  var children = _ref.children,
    checkout = _ref.checkout,
    title = _ref.title;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root, checkout && styles.checkout),
    title: title
  }, checkout && /*#__PURE__*/React.createElement("div", {
    className: styles.checkCircle
  }, /*#__PURE__*/React.createElement(Icon, {
    material: true,
    name: "check circle outline"
  })), children);
};
export var Content = function Content(_ref2) {
  var children = _ref2.children,
    checkout = _ref2.checkout;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.content, checkout && styles.checkout)
  }, children);
};
export var Info = function Info(_ref3) {
  var children = _ref3.children,
    checkout = _ref3.checkout;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.info, checkout && styles.checkout)
  }, children);
};
export var Label = function Label(_ref4) {
  var children = _ref4.children,
    checkout = _ref4.checkout;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.label, checkout && styles.checkout)
  }, children);
};
export var Editor = function Editor(_ref5) {
  var children = _ref5.children,
    checkout = _ref5.checkout;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.editor, checkout && styles.checkout)
  }, children);
};
export var Children = function Children(_ref6) {
  var children = _ref6.children,
    checkout = _ref6.checkout;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.children, checkout && styles.checkout)
  }, children);
};
//# sourceMappingURL=index.js.map
